import { Box, Grid, styled } from "@mui/material";
import MxDetailSmallCard from "../MxDetailCardSmall";
import MxDetailCardAgentPicture from "./MxDetailCardAgentPicture";
import MxDetailCardAgentName from "./MxDetailCardAgentName";
import MxDetailCardAgentAgency from "./MxDetailCardAgentAgency";
import MxDetailCardAgentEmail from "./MxDetailCardAgentEmail";
import MxDetailCardAgentPhone from "./MxDetailCardAgentPhone";
import { IconBrandWhatsapp, IconMessageFilled } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";

interface agentItem {
  name: string;
  email: string;
  agencyName: string;
  phone?: string;
  picture?: string;
  WhatsappCallback?: (e: agentItem) => void;
  messageCallback?: (e: agentItem) => void;
  clickCallback?: (e: agentItem) => void;
  getExtraDataCallback?: (e: any) => any;
}

export interface MxDetailCardAgentProps {
  agents: agentItem[] | [];
  title: string;
}

const MxDetailCardAgent = (props: MxDetailCardAgentProps) => {
  return (
    <MxDetailSmallCard title={props.title}>
      <Grid container rowGap={2}>
        {props.agents.map(x => (
          <Grid container position="relative" alignItems="center">
            <Grid item xs="auto">
              <MxDetailCardAgentPicture
                src={x.picture}
                alt={x.name}
                objectFit="cover"
              />
            </Grid>
            <Grid container item xs={8} rowGap={1} textAlign="center">
              <Grid item xs={12}>
                <MxDetailCardAgentName name={x.name} />
              </Grid>
              <Grid item xs={12}>
                <MxDetailCardAgentAgency name={x.agencyName} />
              </Grid>
              <Grid item xs={12}>
                <MxDetailCardAgentPhone phone={x.phone ?? ""} />
              </Grid>
              <Grid item xs={12}>
                <MxDetailCardAgentEmail email={x.email ?? ""} />
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs="auto"
              flexDirection={"column"}
              rowGap={1.1}
              position="absolute"
              top={15}
              right={4}
            >
              {x.WhatsappCallback && (
                <Grid item xs="auto">
                  <MxIcons
                    color="primary.main"
                    size={22}
                    onClick={() => x.WhatsappCallback && x.WhatsappCallback(x)}
                  >
                    <IconBrandWhatsapp />
                  </MxIcons>
                </Grid>
              )}

              {x.messageCallback && (
                <Grid item xs="auto">
                  <MxIcons
                    color="primary.main"
                    size={22}
                    onClick={() => x.messageCallback && x.messageCallback(x)}
                  >
                    <IconMessageFilled />
                  </MxIcons>
                </Grid>
              )}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </MxDetailSmallCard>
  );
};

export default MxDetailCardAgent;
